import type { ZolaFileResponseType } from 'actions/types/UploadcareActions';
import type {
  CreatePhotoRequest,
  CreatePhotosRequest,
  UpdatePhotoRequest,
  UpdatePhotosRequest,
  WCmsPhotoView,
} from '@zola/svc-web-api-ts-client';

export type CreatePhotosPayload = {
  zolaFiles: ZolaFileResponseType[];
};

export type UpdatePhotosPayload = {
  photosQueue: Record<number, WCmsPhotoView>;
};

export const buildCreatePhotosPayload = ({
  zolaFiles,
}: CreatePhotosPayload): CreatePhotosRequest => {
  const photosArr: CreatePhotoRequest[] = zolaFiles.map(file => ({
    caption: undefined,
    image_id: file.uuid,
  }));
  return { create_photo_requests: photosArr };
};

export const buildUpdatePhotosPayload = ({
  photosQueue,
}: UpdatePhotosPayload): UpdatePhotosRequest => {
  const photoQueueKeys = Object.keys(photosQueue);
  const updatedPhotosArr: UpdatePhotoRequest[] = [];
  photoQueueKeys.forEach((key: string) => {
    const photo = photosQueue[Number(key)];

    if (photo.caption && photo.caption.length > 200) {
      throw new Error();
    }

    updatedPhotosArr.push({
      id: photo.id,
      image_id: photo.image_id,
      caption: photo.caption,
    });
  });
  return { update_photo_requests: updatedPhotosArr };
};
